import React, { useEffect, useState } from "react";
import useCeo from "../../hooks/useCEO";
import { useUnidades } from "../../hooks/test/useUnidades";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import { Spinner } from "../../components/Spinner";

const AES = require("mysql-aes");
export const GeneracionCodigos = () => {

    useCeo({
        title: "GENERACION DE CÓDIGOS",
        description: "Página dedicada a generar códigos de aperturas para las unidades",
    });

    const {
        estatusContingencia,
        activarContingenciaNegocios,
        postCodigos,
        postCodigosToken,
        getNegocios,
        getNegocioContingencia,
        postContingencia,
        actualizarNumCodigos,
        putListResetCodigos,
    } = useUnidades();
    const [economico, setEconomico] = useState("");
    const [economico2, setEconomico2] = useState("");
    const [resetEconomico, setResetEconomico] = useState("");
    const [codigo_token, setCodigo_token] = useState("");
    const [codigoGenerado, setCodigoGenerado] = useState("");
    const [codigoGenerado2, setCodigoGenerado2] = useState("");
    const [consecutivoCodigo, setConsecutivoCodigo] = useState();
    const [consecutivoCodigo2, setConsecutivoCodigo2] = useState();
    const [codigoGeneradoToken, setCodigoGeneradoToken] = useState("");
    const [listaNegocios, setListaNegocios] = useState([]);
    const [estatus, setEstatus] = useState(false);
    const [loading, setLoading] = useState(false);
    const [actContingenciamod, setActContingenciamod] = useState("");
    const toastId = React.useRef(null);
    const notify = () => toastId.current = toast("Espere por favor...", { autoClose: false });
    const [form, setForm] = useState({
        negocioId: "",
        intentos_teclado_principal: "",
        intentos_teclado_emergente: "",
        actContingencia: "",
    });

    useEffect(() => {
        getListaNegocios();
        getEstatusContingencia();
    }, []);

    const getEstatusContingencia = async () => {
        setLoading(true);
        const resp = await estatusContingencia();
        if (!resp.ok) return;
        setEstatus(resp.active);
        setLoading(false);
    };

    const getListaNegocios = async () => {
        let resp = await getNegocios();
        if (!resp.ok) return;
        setListaNegocios([...resp.negocios]);
    };

    const handleChange = (e) => {
        setEconomico(e.target.value);
    };

    const handleChange2 = (e) => {
        setEconomico2(e.target.value);
    }

    const handleChangeToken = (e) => {
        setCodigo_token(e.target.value);
    };

    const reset_list_codigos = async () => {
        if (resetEconomico == "") {
            showToastError("Por favor inserta el económico de la unidad a resetear");
        } else {
            Swal.fire({
                title: "¿Seguro que deseas resetear la lista de codigos de esta unidad?",
                text: "¿Confirmar?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Sí",
                cancelButtonText: "Cancelar",
            }).then(async (resultado) => {
                if (resultado.value) {
                    const id = toast.loading("Espere por favor...", {
                        position: toast.POSITION.BOTTOM_CENTER,
                    });

                    // Ejecuta método para generar nuevo código de apertura
                    await putListResetCodigos(resetEconomico)
                        .then((res) => {
                            console.log(res);
                            if (res.ok) {
                                setResetEconomico("");
                                toast.dismiss(id);
                                toast.success("Códigos reseteados correctamente!", {
                                    position: toast.POSITION.BOTTOM_CENTER,
                                });
                            } else {
                                toast.dismiss(id);
                                Swal.fire({
                                    icon: "warning",
                                    title: res.msg,
                                    showConfirmButton: true,
                                    confirmButtonText: "OK",
                                });

                                setResetEconomico("");
                            }
                        })
                        .catch((err) => {
                            toast.update(id, {
                                render: "Error al resetear la lista de códigos",
                                type: "error",
                                isLoading: false,
                            });
                            console.log("err: ", err);
                        });

                }
            });
        }
    };

    const generar_codigo = async (eco, tipoLista) => {
        if (eco == "") {
            showToastError("Por favor inserta el económico de la unidad");
        } else {
            Swal.fire({
                title: "¿Seguro que deseas generar un nuevo código de esta unidad?",
                text: "¿Confirmar?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Sí",
                cancelButtonText: "Cancelar",
            }).then(async (resultado) => {
                if (resultado.value) {
                    let obj = {
                        eco: eco,
                        tipo_lista: tipoLista,
                    };

                    const id = toast.loading("Espere por favor...", {
                        position: toast.POSITION.BOTTOM_CENTER,
                    });

                    // Ejecuta método para generar nuevo código de apertura
                    await postCodigos(obj)
                        .then((res) => {
                            console.log(res);
                            if (res.ok) {
                                let encrypted = res.codigo[0].codigo;
                                let consecutivo = res.codigo[0].consecutivo;
                                let buf = Buffer.from(encrypted, "utf-8");
                                let codigo = AES.decrypt(buf.toString("hex"), "gGH#uCnWp^oqq#3o");

                                if (tipoLista === 1) {
                                    setConsecutivoCodigo(consecutivo);
                                    setCodigoGenerado(codigo);
                                }

                                if (tipoLista === 2) {
                                    setConsecutivoCodigo2(consecutivo);
                                    setCodigoGenerado2(codigo);
                                }

                                toast.dismiss(id);
                                toast.success("Código generado correctamente!", {
                                    position: toast.POSITION.BOTTOM_CENTER,
                                });
                            } else {
                                toast.dismiss(id);
                                Swal.fire({
                                    icon: "warning",
                                    title: res.msg,
                                    showConfirmButton: true,
                                    confirmButtonText: "OK",
                                });

                                setEconomico("");
                                setEconomico2("");
                                setCodigoGenerado("");
                            }
                        })
                        .catch((err) => {
                            toast.update(id, {
                                render: "Error al generar el código",
                                type: "error",
                                isLoading: false,
                            });
                            console.log("err: ", err);
                        });
                }
            });
        }
    };

    const generar_codigo_token = async () => {
        if (codigo_token == "") {
            showToastError("Por favor inserta el código");
        } else
            if (codigo_token.length !== 6) {
                showToastError("El código debe contener 6 dígitos");
            } else {
                let obj = {
                    codigo_acceso: codigo_token,
                };
                notify();
                // Ejecuta método para generar nuevo código de apertura
                let res = await postCodigosToken(obj)
                if (res.ok) {
                    setCodigoGeneradoToken(res.codigo);
                    toast.update(toastId.current, { type: toast.TYPE.SUCCESS, render: res.msg, autoClose: 5000 });
                } else {
                    toast.update(toastId.current, { type: toast.TYPE.ERROR, render: res.msg, autoClose: 5000 });
                    setCodigo_token("");
                    setCodigoGeneradoToken("");
                }
            }
    };

    const showToastError = (msj = "Ha ocurrido un error") => {
        toast.error(msj, {
            position: "bottom-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });
    };

    const getNegocioId = async (id) => {
        let resp = await getNegocioContingencia(id);
        if (resp.ok) {
            setForm({
                ...form,
                negocioId: resp.negocio.negocio_id,
                intentos_teclado_principal: resp.negocio.codigos_intento_1,
                intentos_teclado_emergente: resp.negocio.codigos_intento_2,
                actContingencia: resp.negocio.contingencia_activada,
            });

            setActContingenciamod(resp.negocio.contingencia_activada);

        }
    };

    const guardarConfig = async () => {

        let formNumCodigos = {
            codigos_intento_1: parseInt(form.intentos_teclado_principal),
            codigos_intento_2: parseInt(form.intentos_teclado_emergente),
        };

        if (actContingenciamod !== form.actContingencia) {
            let formUpdateContingenciaNegocio = {
                activa: actContingenciamod,
                cedis_id: 0,
                id_negocio: form.negocioId,
            };

            const id = toast.loading("Espere por favor...", {
                position: toast.POSITION.BOTTOM_CENTER,
            });
            let resp = await postContingencia(formUpdateContingenciaNegocio);

            if (resp.ok && resp.code === "Activado") {
                let res = await actualizarNumCodigos(form.negocioId, formNumCodigos);
                if (res.ok) {
                    toast.dismiss(id);
                    Swal.fire({
                        icon: "success",
                        title: "Flujo modificado",
                        showConfirmButton: false,
                        timer: 1500,
                    });
                } else {
                    toast.dismiss(id);
                    Swal.fire({
                        icon: "error",
                        title: res.msg,
                        showConfirmButton: true,
                        confirmButtonText: "OK",
                    });
                }
            } else if (resp.ok && resp.code === "Desactivado") {
                toast.dismiss(id);
                let res = await actualizarNumCodigos(form.negocioId, formNumCodigos);
                if (res.ok) {
                    toast.dismiss(id);
                    Swal.fire({
                        icon: "success",
                        title: "Flujo modificado",
                        showConfirmButton: false,
                        timer: 1500,
                    });
                } else {
                    toast.dismiss(id);
                    Swal.fire({
                        icon: "error",
                        title: res.msg,
                        showConfirmButton: true,
                        confirmButtonText: "OK",
                    });
                }
            } else if (
                !resp.ok &&
                resp.msg ===
                "Lo siento, no se puede activar la contingencia. Consulte a su administrador de negocio"
            ) {
                let res = await actualizarNumCodigos(form.negocioId, formNumCodigos);
                if (res.ok) {
                    toast.dismiss(id);
                    Swal.fire({
                        icon: "success",
                        title: "Flujo modificado",
                        showConfirmButton: false,
                        timer: 1500,
                    });
                } else {
                    toast.dismiss(id);
                    Swal.fire({
                        icon: "error",
                        title: res.msg,
                        showConfirmButton: true,
                        confirmButtonText: "OK",
                    });
                }
            } else {
                toast.dismiss(id);
                Swal.fire({
                    icon: "error",
                    title: resp.msg,
                    showConfirmButton: true,
                    confirmButtonText: "OK",
                });
            }
        } else {
            let res = await actualizarNumCodigos(form.negocioId, formNumCodigos);
            const id = toast.loading("Espere por favor...", {
                position: toast.POSITION.BOTTOM_CENTER,
            });
            if (res.ok) {
                toast.dismiss(id);
                Swal.fire({
                    icon: "success",
                    title: "Flujo modificado",
                    showConfirmButton: false,
                    timer: 1500,
                });
            } else {
                toast.dismiss(id);
                Swal.fire({
                    icon: "error",
                    title: res.msg,
                    showConfirmButton: true,
                    confirmButtonText: "OK",
                });
            }
        }

    };
    const accionContingencia = async (accion) => {
        const resp = await activarContingenciaNegocios(accion);
        if (resp.ok) {
            Swal.fire({
                icon: "success",
                title: resp.msg,
                allowOutsideClick: false,
                confirmButtonText: "OK",
            }).then((result) => {
                /* Read more about isConfirmed, isDenied below */
                if (result.isConfirmed) {
                    getEstatusContingencia();
                }
            })
        } else {
            Swal.fire({
                icon: "error",
                title: resp.msg,
                showConfirmButton: true,
                confirmButtonText: "OK",
            });
        }
    };

    return (
        <>
            {loading && <Spinner />}
            <div className=" container">
                <div className="row" style={{ margin: "10px" }}>
                    <div className="row justify-content-center">
                        <div className="card col-8 card-contingencia-codigo mt-5">
                            <div className="row">
                                <div className="col-9">
                                    <h2>Generar código de apertura de la lista principal </h2>
                                    <div className="d-flex" id="generar-codigo">
                                        <input
                                            className="form-control me-2"
                                            type="search"
                                            placeholder="Escribe el económico de la unidad"
                                            aria-label="Search"
                                            value={economico}
                                            onChange={handleChange}
                                        />
                                        <button
                                            className="btn btn-outline-success"
                                            type="submit"
                                            onClick={() => generar_codigo(economico, 1)}
                                        >
                                            GENERAR
                                        </button>
                                    </div>
                                </div>
                                <div className="col-1">
                                    <h2>N°</h2>
                                    <input
                                        id="inputCodigo"
                                        className="form-control me-2"
                                        type="text"
                                        disabled
                                        style={{ margin: "0" }}
                                        value={consecutivoCodigo}
                                    />
                                </div>
                                <div className="col-2">
                                    <h2>Código</h2>
                                    {/* <br/> */}
                                    <input
                                        id="inputCodigo"
                                        className="form-control me-2"
                                        type="text"
                                        disabled
                                        style={{ margin: "0" }}
                                        value={codigoGenerado}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                        
                    <div className="row justify-content-center">
                        <div className="card col-8 card-contingencia-codigo mt-5">
                            <div className="row">
                                <div className="col-9">
                                    <h2>Generar código de apertura de la lista emergente</h2>
                                    <div className="d-flex" id="generar-codigo">
                                        <input
                                            className="form-control me-2"
                                            type="search"
                                            placeholder="Escribe el económico de la unidad"
                                            aria-label="Search"
                                            value={economico2}
                                            onChange={handleChange2}
                                        />
                                        <button
                                            className="btn btn-outline-success"
                                            type="submit"
                                            onClick={() => generar_codigo(economico2, 2)}
                                        >
                                            GENERAR
                                        </button>
                                    </div>
                                </div>
                                <div className="col-1">
                                    <h2>N°</h2>
                                    <input
                                        id="inputCodigo"
                                        className="form-control me-2"
                                        type="text"
                                        disabled
                                        style={{ margin: "0" }}
                                        value={consecutivoCodigo2}
                                    />
                                </div>
                                <div className="col-2">
                                    <h2>Código</h2>
                                    {/* <br/> */}
                                    <input
                                        id="inputCodigo"
                                        className="form-control me-2"
                                        type="text"
                                        disabled
                                        style={{ margin: "0" }}
                                        value={codigoGenerado2}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div className="row justify-content-center">
                        <div className="card col-8 card-contingencia-codigo mt-5">
                            <div className="row">
                                <div className="col-9">
                                    <h2>Generar código de apertura por token</h2>
                                    <div className="d-flex" id="generar-codigo">
                                        <input
                                            className="form-control me-2"
                                            type="search"
                                            placeholder="Escribe el código"
                                            aria-label="Search"
                                            size={6}
                                            value={codigo_token}
                                            onChange={handleChangeToken}
                                        />
                                        <button
                                            className="btn btn-outline-success"
                                            type="submit"
                                            onClick={generar_codigo_token}
                                        >
                                            GENERAR
                                        </button>
                                    </div>
                                </div>
                                <div className="col-3">
                                    <h2>Código</h2>
                                    {/* <br/> */}
                                    <input
                                        id="inputCodigo"
                                        className="form-control me-2"
                                        type="text"
                                        disabled
                                        style={{ margin: "0" }}
                                        value={codigoGeneradoToken}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}